import Immutable from 'immutable';

const LOAD = 'managers/LOAD';
const LOAD_SUCCESS = 'managers/LOAD_SUCCESS';
const LOAD_FAIL = 'managers/LOAD_FAIL';
const LOAD_ADD_SUCCESS = 'managers/LOAD_ADD_SUCCESS';


const initialState = Immutable.fromJS({
  managers: null,
  loading: false,
  errorMessage: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case LOAD:
    return state
    .set('loading', true);

    case LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('managers', action.managers);


    case LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('managers', action.result);

    default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/managers.js